export default __webpack_public_path__ + "static/media/lijoane.74d43bea.jpg";